import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Select, MenuItem } from '@material-ui/core';

import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import { lime } from '@material-ui/core/colors';
import Modal from '../../components/Modal';
import GreenCard from '../../components/GreenCard';

import { setCarInsurance, setValidCar } from '../../redux/carInsurance';

import { useFormik } from 'formik';

import api from '../../api';
import { setErrorMessage } from '../../redux/errors';
import { mapErrorMessage } from '../../utils';

const builInitialValues = () => {
  let carInfo = {
    carVersion: '',
  };
  return carInfo;
};

export default function AddVersion(props) {
  const { nextWasRequired, modelId } = props;
  // Checking model card selected for disabled version input
  const { modelSelected } = useSelector(({ carInsurance }) => ({
    modelSelected: carInsurance?.userCarInsurance?.carModel
  }));


  const dispatch = useDispatch();

  const history = useHistory();

  const [open, setOpen] = useState(false);

  const onClick = () => {
    setOpen(true);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  const renderModal = () => {
    return <GreenCard closeModal={closeModal} />;
  };

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carBrand: carInsurance.userCarInsurance.carBrand,
    carModel: carInsurance.userCarInsurance.carModel,
    carYear: carInsurance.userCarInsurance.carYear,
    carVersion: carInsurance.userCarInsurance.carVersion,
  }));

  const initialValues = builInitialValues(userCarInsurance);

  const { values, errors, touched, setFieldValue, handleBlur } = useFormik({
    initialValues,
  });

  // useEffect(() => {
  //   const validationErrors = Object.keys(errors).length > 0;
  //   const valuesRequired = values.carVersion && true;

  //   if (!validationErrors && valuesRequired) {
  //     dispatch(setValidCar({ isValid: true }));
  //   }
  //   if (validationErrors || !valuesRequired) {
  //     dispatch(setValidCar({ isValid: false }));
  //   }
  // }, [values, errors]);

  const hasError = (input, inputValue) =>
    (touched[input] && errors[input]) || (nextWasRequired && inputValue === '');

  const error = 'campo obligatorio';

  function handleChange(e) {
    const key = e.target.name;
    let value = e.target.value;
    setFieldValue(key, value);
    dispatch(setCarInsurance({ [key]: value }));
    let carVersionName =
      dataAutos.vehicleBrand[0].vehicleGroups[0].vehicleModels.find(
        (e) => e.vehicleModelId == value
      ).description;
    dispatch(setCarInsurance({ carVersionName: carVersionName }));
  }

  useEffect(() => {
    dispatch(setCarInsurance({ carVersion: '' }));
    values.carModel = null;
    if (modelId) {
      async function fetchDataAutos() {
        try {
          const { data } = await api.post(
            `/seguros/vehiculo/precio/ch/PDS`,
            {
              generic: {
                infoAutoCode: '',
                listGroups: '',
                listModels: '',
                productionYear: userCarInsurance.carYear,
              },
              vehicleBrand: {
                vehicleBrandId: userCarInsurance.carBrand,
              },
              vehicleGroup: {
                vehicleGroupId: modelId,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          values.carVersion = '';
          setDataAutos(null);
          dispatch(setCarInsurance({ carVersion: '' }));

          setDataAutos(data);
        } catch (error) {
          dispatch(setErrorMessage(mapErrorMessage('systemError')));
          history.push(`/error`);
        }
      }
      fetchDataAutos();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [userCarInsurance.carBrand, modelId]);

  const { token } = useSelector(({ auth }) => ({
    token: auth.token,
  }));

  const [dataAutos, setDataAutos] = useState();

  return (
    <>
      {open && <Modal>{renderModal()}</Modal>}
      <div className='input-field col s10 l4'>
        <Select
          defaultValue=''
          value={values.carVersion}
          id='carVersion'
          name='carVersion'
          type='text'
          className={`validate inputField ${
            hasError('carVersion', values.carVersion) ? 'error' : ''
          }`}
          classes={{ root: 'menuSelect', icon: 'caret' }}
          inputProps={{
            classes: {
              icon: 'caret',
            },
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={ dataAutos && modelSelected ? false : true }
        >
          {dataAutos &&
            modelId &&
            dataAutos.vehicleBrand[0].vehicleGroups[0].vehicleModels.map(
              (item, key) => {
                return (
                  <MenuItem key={key} value={item.vehicleModelId}>
                    {item.description}
                  </MenuItem>
                );
              }
            )}
        </Select>
        <span htmlFor='carVersion'>Version</span>
        <p className='error-text error-selected'>
          {hasError('carVersion', values.carVersion) && error}
        </p>
      </div>

      <div className='col s2 l2 icon-help'>
        <div onClick={onClick}>
          <HelpOutlineRoundedIcon style={{ color: lime[600] }} />
        </div>
      </div>
    </>
  );
}
